// initial state
const state = {
  user: {
    sessionId: "",
    userId: "",
    mobile: "",
    freeChangePad:'',
    changePadPrice:'',
    freeChangePadNum:0,
  },
  scoreInfo:{//积分信息
    score:'',
    ratio:''
  },
  language:'zh',
  announcementList:[],//系统公告
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  setUser(state, user) {
    //设置参数
    state.user = user;
  },
  setScoreInfo(state, scoreInfo) {
    state.scoreInfo = scoreInfo;
  },
  setLanguage(state, language) {
    state.language = language;
  },
  setAnnouncementList(state, announcementList) {
    state.announcementList = announcementList;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/module/user.js